module.exports = __webpack_public_path__ + "img/hochfeiler.3c2d282c.jpg";